// extracted by mini-css-extract-plugin
export var label = "QuoteAndProduct-module--label--zT72w";
export var productCard = "QuoteAndProduct-module--productCard--onVmQ";
export var productContent = "QuoteAndProduct-module--productContent--rUykf";
export var productWrapper = "QuoteAndProduct-module--productWrapper--dgQHk";
export var quote = "QuoteAndProduct-module--quote--Fwuz1";
export var quoteContent = "QuoteAndProduct-module--quoteContent--UWfIM";
export var quoteWrapper = "QuoteAndProduct-module--quoteWrapper--An2fW";
export var wrapper = "QuoteAndProduct-module--wrapper--8sS+U";